module.exports = __webpack_public_path__ + "assets/img/icon-track.89ff19b8.png";